interface FleetLocators {
    card: (name: string) => string;
}

export const FLEET_LOCATORS: FleetLocators = {
    card: (name: string): string => `card-${name}`,
};
